export default "* Hvad krævede det af fiskeren for at have fiskelykke i jægerstenalderen?\n* Hvilke typer fisk vil det være nemmest at fange med fiskespyd? \n";